import { CourseCurriculumContentEntity } from '@redux/course/type/courseDetailType';

abstract class CurriculumContentStrategy {
  protected readonly id: number;

  protected readonly name: string;

  protected readonly duration: number;

  protected readonly attachmentCount: number;

  constructor(content: CourseCurriculumContentEntity) {
    this.id = content.id;
    this.name = content.name;
    this.duration = content.duration ?? 0;
    this.attachmentCount = content.attachmentCount ?? 0;
  }

  getId() {
    return this.id;
  }

  getName() {
    return this.name;
  }

  getDuration() {
    return this.duration;
  }

  getAttachmentCount() {
    return this.attachmentCount;
  }
}

export default CurriculumContentStrategy;
